import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent, IconComponent } from '@sc/ui-components';

@Component({
  selector: 'sc-recurrent-event-delete-dialog',
  styleUrls: ['./recurrent-event-delete-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [
    IconComponent,
    ReactiveFormsModule,
    MatRadioModule,
    ButtonComponent,
    TranslateModule,
  ],
  template: `
    <div class="dialog-container">
      <div class="dialog-head">
        <button type="button" class="close-btn" (click)="onCloseClick()">
          <sc-icon name="close"></sc-icon>
          <span class="sr_only">{{
            'GlobalApplicativeConstants.accessibility.closeDialog'
              | translate
                : {
                    dialogTitle:
                      'RecurrentEventDeleteDialog.dialogTitle' | translate
                  }
          }}</span>
        </button>
      </div>

      <div class="dialog-content">
        <h1
          mat-dialog-title
          class="sc-design-title-h2"
          id="recurrent-event-delete-title-id"
        >
          {{ 'RecurrentEventDeleteDialog.dialogTitle' | translate }}
        </h1>

        <div class="dialog-body" [formGroup]="form">
          <label class="radio-group-label sc-design-text-3-bold">{{
            'RecurrentEventDeleteDialog.questionText' | translate
          }}</label>
          <mat-radio-group formControlName="eventsToDelete">
            <mat-radio-button
              value="only-this-event"
              class="sc-design-text-4"
              >{{
                'RecurrentEventDeleteDialog.questionChoiceOnlyThisOne'
                  | translate
              }}</mat-radio-button
            >
            <mat-radio-button value="all-next" class="sc-design-text-4">{{
              'RecurrentEventDeleteDialog.questionChoiceAllNext' | translate
            }}</mat-radio-button>
            <mat-radio-button value="all" class="sc-design-text-4">{{
              'RecurrentEventDeleteDialog.questionChoiceAll' | translate
            }}</mat-radio-button>
          </mat-radio-group>
        </div>

        <div class="dialog-actions">
          <sc-button
            class="cancel-button"
            buttonType="secondary"
            (click)="onCloseClick()"
            >{{ 'RecurrentEventDeleteDialog.cancelBtn' | translate }}</sc-button
          >
          <sc-button
            class="validate-button"
            [disabled]="!form.valid"
            (click)="onValidateClick()"
            >{{
              'RecurrentEventDeleteDialog.validateBtn' | translate
            }}</sc-button
          >
        </div>
      </div>
    </div>
  `,
})
export class RecurrentEventDeleteDialogComponent {
  form = new FormGroup({
    eventsToDelete: new FormControl(null, [Validators.required]),
  });

  constructor(
    private readonly dialogRef: MatDialogRef<RecurrentEventDeleteDialogComponent>
  ) {}

  onCloseClick() {
    this.dialogRef.close('cancel');
  }

  onValidateClick() {
    if (!this.form.valid) {
      return;
    }

    this.dialogRef.close(this.form.get('eventsToDelete').value);
  }
}
